module.exports = __webpack_public_path__ + "img/stamp-fruit-roots-coconut.0a004e60.png";